import { render } from "./TaskList.vue?vue&type=template&id=8fb315be&scoped=true"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"

import "./TaskList.vue?vue&type=style&index=0&id=8fb315be&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8fb315be"

export default script